import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Field, reduxForm} from 'redux-form';
import {Badge, Button, ButtonToolbar, Col, Form, Glyphicon, Panel, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {findUsers} from '../../actions/users';
import {scrollToErrors, SelectField, TextField} from '../form/form';
import {Enums} from "../../utils";

const validate = (values, b, c) => {
	const errors = {};
	if (!values.lastName) {
		errors.lastName = 'Zadejte prosím příjmení'
	}

	if (!values.email) {
		errors.email = 'Zadejte prosím email'
	} else if (values.email && (values.email.indexOf('@') <= 0 || values.email.length < 5)) {
		errors.email = 'Neplatný email'
	}

	return errors
};

const asyncValidate = (values, dispatch, props, currentFieldName) => {
	if (!currentFieldName || !values[currentFieldName]) {
		return new Promise((resolve, reject) => resolve())
	}
	const filter = {};
	const errors = Object.assign({}, props.asyncErrors);
	filter[currentFieldName] = values[currentFieldName].trim();
	return new Promise((resolve, reject) => {
		dispatch(findUsers(filter))
			.then((json) => {
				if (json.response) {
					let found = false;
					if (json.response.data) {
						for (let k in json.response.data) {
							if (json.response.data.hasOwnProperty(k)) {
								if (!values.userId || json.response.data[k].userId !== values.userId) {
									found = json.response.data[k].email;
									break
								}
							}
						}
					}
					if (found) {
						errors[currentFieldName] = "Již existuje (" + found + ")";
						reject(errors)
					} else {
						resolve({})
					}
				} else {
					errors[currentFieldName] = "Nepodařilo se ověřit unikátnost";
					reject(errors)
				}

			})
			.catch(err => {
				errors[currentFieldName] = "Nepodařilo se ověřit unikátnost (" + err + ")";
				reject(errors)
			})

	})
};

class UserForm extends Component {

	render() {
		const {handleSubmit, initialValues, submitting, enums, onSaveUser} = this.props;

		const statusOptions = [];
		statusOptions.push({label: 'Aktivní', value: 'ACTIVE'});
		statusOptions.push({label: 'Smazaný', value: 'DELETED'});
		const roleOptions = Enums.createEnumItems(enums, Enums.getKey("role"), true);

		return (
			<Form horizontal onSubmit={handleSubmit((values) => {
				return onSaveUser(values)
			})} className="detail">
				<Row>
					<Col lg={6} lgOffset={3}>
						<Panel>
							<Panel.Heading>
								{initialValues.userId ? <span>Uživatel <Badge className="pull-right">{initialValues.userId}</Badge></span> : <span>Nový uživatel</span>}
							</Panel.Heading>
							<Panel.Body>
								<Row>
									<Col sm={9}>
										<Field label={'Jméno'} name="firstName" type='text' component={TextField} maxLength="100"/>
										<Field label={'Příjmení'} name="lastName" type='text' component={TextField} maxLength="100"/>
										<Field label="E-mail" name="email" type='text' component={TextField} maxLength="100" feedbackSuccess/>
									</Col>
								</Row>
								<Row className="divider">
									<Col sm={9}>
										<Field label="Oprávnění" name="roleId" type="select" component={SelectField} emptyText="(není)"
											options={roleOptions}/>
									</Col>
								</Row>
								<Row className="divider">
									<Col sm={9}>
										<Field label="Stav" name="status" type="select" component={SelectField} options={statusOptions}/>
									</Col>
								</Row>
							</Panel.Body>
						</Panel>
					</Col>
				</Row>
				<Row>
					<Col>
						<ButtonToolbar className="text-center">
							<Link to={{pathname: "/uzivatele" + (initialValues.userId ? "/" + initialValues.userId : "")}} className="btn btn-default"><Glyphicon glyph="remove"/> Storno</Link>
							<Button bsStyle="success" type="submit" disabled={submitting}><Glyphicon glyph="ok"/> {initialValues.userId ? "Uložit změny" : "Založit uživatele"}</Button>
						</ButtonToolbar>
					</Col>
				</Row>
			</Form>
		)
	}
}

UserForm = reduxForm({
	form: 'user',
	validate,
	asyncValidate,
	onSubmitFail: scrollToErrors,
	asyncBlurFields: ['email']
})(UserForm);

UserForm.propTypes = {
	id: PropTypes.number,
	item: PropTypes.object.isRequired,
	isFetchingItem: PropTypes.bool.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	onSaveUser: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default UserForm



// WEBPACK FOOTER //
// ./src/components/user/UserForm.js